<template>
  <el-dialog
    title="导入续费资料"
    :visible.sync="show"
    width="600px"
  >
    <div class="content">
      <div class="flex">
        <el-upload
          class="upload"
          action=""
          drag
          :http-request="({ file }) => {}"
          :show-file-list="false"
          :on-change="onChange"
        >
          <div v-if="!file" >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </div>
          <div v-else class="upload-content">
            {{ file.name }}
          </div>
        </el-upload>
        <div class="template" @click="handleExport">
          <span>下载模板</span>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="type" @click="$emit('update:visible')">取 消</el-button>
      <el-button size="type" type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name:"ImportRenewalInfo",
  props:{
    visible:{
      type:Boolean,
      default:false
    },
  },
  data(){
    return {
      file:null,
    }
  },
  computed:{
    show:{
      get(){
        return this.visible;
      },
      set(val){
        this.$emit('update:visible',val);
      }
    },
  },
  watch:{
    visible:{
      handler(val){
        if(val){
          this.init();
        }
      }
    },
  },
  methods:{
    onChange(file){
      this.file = file.raw;
    },
    //下载模板
		handleExport() {
			window.open('/externalSimRenewPrice/downloadTemplate.json');
		},
    init(){
      this.file = null;
    },
    // 备注
    async onConfirm(){
      try{
        if(!this.file) throw { msg:'请上传文件' };
        let formData = new FormData();
        formData.append('file', this.file);
        const res = await this.$API.importExternalSimRenewPrice(formData);
        console.log(res,'res')
        if(res.data.code !== 0) throw { msg:res.data.msg };
        this.$message({
          type:'success',
          message:'成功'
        });
        this.$emit('update:visible',false);
        this.$emit('onSuccess');
      }catch({ msg }){
        this.$message({
          type:'warning',
          message:msg
        });
      }
    }
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body{
  padding: 0 20px 10px;
}
::v-deep .el-dialog__footer{
  padding: 0 20px 10px;
}
.content{
  .flex{
    display: flex;
    justify-content: center;
    flex-direction: column;
    .upload{
      text-align: center;
      width: 100%;
      ::v-deep .el-upload{
        width: 100%;
        .el-upload-dragger{
          width: 100%;
        }
      }
      .upload-content{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .template{
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-top: 15px;
      >span{
        cursor: pointer;
        color: #4B88F6;
      }
    }
  }
}
</style>
